"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _layoutModule = _interopRequireDefault(require("./layout.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapColorToClassName = function mapColorToClassName(color) {
  if (color === "yellow") {
    return _layoutModule.default["yellow"];
  }

  return "";
};

var Layout = function Layout(props) {
  var id = props.id,
      children = props.children,
      color = props.color;
  return _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(_layoutModule.default["farbfeld"], _layoutModule.default["stripes"], mapColorToClassName(color), _layoutModule.default["shadow"])
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_layout_wrapper") : null,
    className: "slots quart"
  }, children));
};

Layout.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** String with the color of Layout */
  color: _propTypes.default.oneOf(['yellow']),

  /** The elements that layout component will wrap */
  children: _propTypes.default.element
};
var _default = Layout;
exports.default = _default;